import Styles from './ScrollButton.module.scss'
import cx from 'classnames'
import { EmblaCarouselType } from 'embla-carousel'
import { ChevronRight } from 'blaze-ui/icons/24'
import { useNextButton } from 'components/Carousel/useNextButton'

interface Props {
  emblaApi: EmblaCarouselType
  size?: 'xs' | 'sm' | 'md'
}

export const NextButton = ({ emblaApi, size = 'md' }: Props) => {
  const { isFocusVisible, isDisabled, isPressed, buttonProps, buttonRef } = useNextButton({ emblaApi })

  return (
    <button
      ref={buttonRef}
      className={cx(Styles.scrollButton, Styles[size], {
        [Styles.disabled]: isDisabled,
        [Styles.pressed]: isPressed,
        [Styles.focused]: isFocusVisible,
      })}
      disabled={isDisabled}
      aria-label="Next"
      {...buttonProps}
    >
      <ChevronRight size={size === 'xs' ? 14 : 28} />
    </button>
  )
}
